<template>
    <div class="edit-audit">
        <b-card>
            <b-card-title>
                <b-container>
                    <b-row>
                        <b-col class="text-left">
                            Template:
                        </b-col>
                        <b-col class="text-left">
                            <span> {{template.name}}</span>
                        </b-col>
                        <b-col class="text-right" v-if="template.desc">
                            Description:
                        </b-col>
                        <b-col class="text-left" v-if="template.desc">
                            <span> {{template.desc}}</span>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card-title>
        </b-card>
        <b-card title="Checklists">
            <div v-if="isLoading">
                <b-spinner></b-spinner>
            </div>
            <div v-if="!isLoading">
                <div
                    role="tablist"
                    v-for="item in checklists"
                    :key="item.id"
                    class="list-item">
                    <b-card no-body class="mb-1">
                        <checklist 
                            :checklist="item"
                        ></checklist>
                    </b-card>
                </div>
            </div>
        </b-card>
    </div>
    
</template>

<script>
import { mapState } from 'vuex'
import ChecklistTemplate from '@/components/ChecklistTemplate'
//import Checklist from '../components/Checklist.vue'

export default {
    name: 'CurrentTemplate',
    data() {
        return {
        }
    },
    components: {
        "checklist": ChecklistTemplate,
    },
    computed: {
        ...mapState({
            templates: state => state.templates.all,
            checklistsByTemplate: state => state.templates.checklistByTemplate,
        }),
        template: function() {
            let tmpl = this.templates.find(t=> t.id == this.$route.params.id) 
            if(!tmpl) tmpl = {};
            return tmpl;
        },
        checklists: function() {
            let id = this.$route.params.id;
            let c = this.checklistsByTemplate[id]
            if (!c) {
                this.$store.dispatch('templates/loadChecklistsForTemplate', id)
                c = null
            }
            return c;
        },
        isLoading: function() { 
            return !this.checklists
        }
    },
    methods: {
        getQuestions(id) {
            if(this.checklists){
                return this.checklists.find(c => c.id == id).questions
            }
            return []
        },
        getSublists(id) {
            console.log("getSublists", id)
        }
    }
}
</script>